// Google Analytics 4 (GA4) Service
// The Google tag (gtag.js) is loaded in public/index.html, which also sends the initial page_view.

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-5X26S8JYV0';

// Track page view
export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path || window.location.pathname + window.location.search,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
  // Also log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log('Analytics Event:', eventName, eventParams);
  }
};

// E-commerce tracking events
export const analytics = {
  // Track add to cart
  addToCart: (item) => {
    trackEvent('add_to_cart', {
      currency: 'PKR',
      value: item.price * (item.quantity || 1),
      items: [{
        item_id: item.id,
        item_name: item.name,
        item_category: item.category || 'General',
        price: item.price,
        quantity: item.quantity || 1,
      }],
    });
  },

  // Track remove from cart
  removeFromCart: (item) => {
    trackEvent('remove_from_cart', {
      currency: 'PKR',
      value: item.price * item.quantity,
      items: [{
        item_id: item.id,
        item_name: item.name,
        item_category: item.category || 'General',
        price: item.price,
        quantity: item.quantity,
      }],
    });
  },

  // Track view item
  viewItem: (item) => {
    trackEvent('view_item', {
      currency: 'PKR',
      value: item.price,
      items: [{
        item_id: item.id,
        item_name: item.name,
        item_category: item.category || 'General',
        price: item.price,
      }],
    });
  },

  // Track begin checkout
  beginCheckout: (items, total) => {
    trackEvent('begin_checkout', {
      currency: 'PKR',
      value: total,
      items: items.map(item => ({
        item_id: item.id,
        item_name: item.name,
        item_category: item.category || 'General',
        price: item.price,
        quantity: item.quantity || 1,
      })),
    });
  },

  // Track purchase (when order is confirmed)
  purchase: (transactionId, items, total, shipping = 0) => {
    trackEvent('purchase', {
      transaction_id: transactionId,
      value: total + shipping,
      currency: 'PKR',
      shipping: shipping,
      items: items.map(item => ({
        item_id: item.id,
        item_name: item.name,
        item_category: item.category || 'General',
        price: item.price,
        quantity: item.quantity || 1,
      })),
    });
  },

  // Track add to favorites
  addToFavorites: (item) => {
    trackEvent('add_to_wishlist', {
      currency: 'PKR',
      value: item.price,
      items: [{
        item_id: item.id,
        item_name: item.name,
        item_category: item.category || (item.isDeal ? 'Deal' : 'General'),
        price: item.price,
      }],
    });
  },

  // Track remove from favorites
  removeFromFavorites: (item) => {
    trackEvent('remove_from_wishlist', {
      currency: 'PKR',
      value: item.price,
      items: [{
        item_id: item.id,
        item_name: item.name,
        item_category: item.category || (item.isDeal ? 'Deal' : 'General'),
        price: item.price,
      }],
    });
  },

  // Track modal open
  openModal: (modalName) => {
    trackEvent('modal_open', {
      modal_name: modalName,
    });
  },

  // Track modal close
  closeModal: (modalName) => {
    trackEvent('modal_close', {
      modal_name: modalName,
    });
  },

  // Track category filter
  filterByCategory: (category) => {
    trackEvent('filter_by_category', {
      category: category,
    });
  },

  // Track search (if applicable)
  search: (searchTerm) => {
    trackEvent('search', {
      search_term: searchTerm,
    });
  },

  // Track button clicks
  buttonClick: (buttonName, location) => {
    trackEvent('button_click', {
      button_name: buttonName,
      location: location,
    });
  },

  // Track section view
  viewSection: (sectionName) => {
    trackEvent('view_section', {
      section_name: sectionName,
    });
  },
};

export default analytics;

